<template>
  <div class="content__body" ref="scrollContent">
    <transition name="loading">
      <div v-if="!isLoading">
        <template v-if="canDeactivate">
          <template v-if="unusedJam === 'deactivated'">
            <content-box class="content__withdraw can-deactivate" :width="'800px'">
              <div class="title--wrap">
                <p class="title" v-html="$t('userInfo.myInformation.deactivateInfo.can.title')"></p>
              </div>
              <div class="analytics-page--wrap center">
                <div class="unused-jam--wrap">
                  <div class="description" v-html="$t('plan.DeactivationJam')"></div>
                  <div class="jam-info">
                    <div class="jam">
                      <div class="icon icon--jam--40px"></div>
                      <span>{{ $t('plan.myJam') }}</span>
                    </div>
                    <div class="count">{{ jam.total | thousand }} <span>{{ $t('plan.jamAmount') }}</span></div>
                  </div>
                </div>
              </div>
            </content-box>
            <div class="button--wrap">
              <ui-button class="btn__cancel"
                         @click="onCancelDeactivate">{{ $t('common.cancel') }}</ui-button>
              <ui-button :primary="true"
                         @click="onMoveContactUs">{{ $t('common.contactUs') }}</ui-button>

            </div>
            <back-to-top :refName="'scrollContent'" />
          </template>
          <template v-else>
            <content-box class="content__withdraw can-deactivate" :width="'800px'">
              <div class="title--wrap">
                <p class="title" v-html="$t('userInfo.myInformation.deactivateInfo.can.title')"></p>
                <i class="icon icon--logo-only-ba"></i>
                <i class="icon icon--logo-only-beu"></i>
                <i class="icon icon--logo-only-geo"></i>
                <br><strong v-html="$t('userInfo.myInformation.deactivateInfo.can.desc')"></strong>
              </div>
              <div class="desc--wrap">
                <p v-html="$t('userInfo.myInformation.deactivateInfo.can.desc1')"></p>
                <p v-html="$t('userInfo.myInformation.deactivateInfo.can.desc2')"></p>
              </div>
              <div class="analytics-page--wrap">
                <ul>
                  <li>
                    <h5 v-html="$t('userInfo.myInformation.deactivateInfo.can.analyticsPage.title.info')"></h5>
                    <p v-html="$t('userInfo.myInformation.deactivateInfo.can.analyticsPage.info')"></p>
                  </li>
                  <li v-if="isUsingService.ba">
                    <h5 v-html="$t('userInfo.myInformation.deactivateInfo.can.analyticsPage.title.domain')"></h5>
                    <p v-html="$t(`userInfo.myInformation.deactivateInfo.can.analyticsPage.ba.${deactivateInfo.ba_domain_count > 1 ? 'plural' : 'singular'}`, { baDomainCount: deactivateInfo.ba_domain_count })"></p>
                  </li>
                  <li v-if="isUsingService.beusable">
                    <h5 v-html="$t('userInfo.myInformation.deactivateInfo.can.analyticsPage.title.page')"></h5>
                    <p v-html="$t(`userInfo.myInformation.deactivateInfo.can.analyticsPage.beusable.${deactivateInfo.beusable_page_count > 1 ? 'plural' : 'singular'}`, { beusablePageCount: deactivateInfo.beusable_page_count })"></p>
                  </li>
                </ul>
              </div>
              <div class="chk-box--wrap">
                <ui-checkbox :value="model.withDrawAgree"
                             @input="onChangeCheckboxValue">
                  {{ $t('userInfo.myInformation.deactivateInfo.can.analyticsPage.checkbox') }}
                </ui-checkbox>
                <strong v-if="modelError" class="validation-text">{{ $t('common.validationErrorText.deactivateConfirm') }}</strong>
              </div>
            </content-box>
            <div class="button--wrap">
              <ui-button class="btn__cancel"
                         @click="onCancelDeactivate">{{ $t('common.cancel') }}</ui-button>
              <ui-button :primary="true"
                         :disabled="!model.withDrawAgree"
                         @click="onShowConfirmDeleteLayer">{{ $t('common.confirm') }}</ui-button>
            </div>
            <back-to-top :refName="'scrollContent'" />
          </template>
          <!-- 2차스펙 추가 -->
          <!-- <template>
            <content-box class="content__withdraw can-deactivate" :width="'800px'">
              <div class="title--wrap">
                <p class="title" v-html="$t('userInfo.myInformation.deactivateInfo.can.title')"></p>
              </div>
              <div class="analytics-page--wrap center">
                <div class="unused-jam--wrap">
                  <div class="description"> {{ $t('plan.descriptionWithJam') }} </div>
                  <div class="jam-info">
                    <div class="jam">
                      <div class="icon--small-jam"></div>
                      <span>{{ $t('plan.myJam') }}</span>
                    </div>
                    <div class="count">{{ jam.total }} <span>{{ $t('plan.jamAmount') }}</span></div>
                  </div>
                </div>
                <ui-checkbox :value="model.withDrawAgree"
                               @input="onChangeCheckboxValue">
                    {{ $t('plan.confirmWithJam') }}
                  </ui-checkbox>
                  <strong v-if="modelError" class="validation-text">{{ $t('common.validationErrorText.deactivateConfirm') }}</strong>
              </div>
            </content-box>
            <div class="button--wrap">
              <ui-button class="btn__cancel"
                         @click="onCancelDeactivate">{{ $t('common.cancel') }}</ui-button>
              <ui-button
              :primary="true"
              :disabled="!model.withDrawAgree"
              @click="onShowConfirmDeleteLayer">{{ $t('common.confirm') }}</ui-button>
            </div>
            <back-to-top :refName="'scrollContent'" />
          </template> -->
        </template>
        <template v-else>
          <content-box class="content__withdraw no-deactivate" :width="'800px'">
            <div class="title--wrap">
              <p class="title" v-html="$t('userInfo.myInformation.deactivateInfo.canNot.title')"></p>
            </div>
            <div class="current-plan--wrap">
              <p class="desc" v-html="$t('userInfo.myInformation.deactivateInfo.canNot.currentPlan.desc')"></p>
              <div>
                <ul>
                  <li v-if="isUsingService.ba">
                    <i class="icon icon--logo-only-ba"></i>
                    <span class="plan-name">{{ lastPlan.ba.planName }}</span>
                    <span v-if="lastPlan.ba.bFree"
                          class="expire-date"
                          v-html="$t('userInfo.myInformation.deactivateInfo.can.plan')"></span>
                    <span v-else-if="lastPlan.ba.paymentMethod === 'wire transfer' || lastPlan.ba.coupon || !lastPlan.ba.paymentMethod || ['admin', '4grit'].includes(lastPlan.ba.paymentMethod) || (nextPlan.ba && nextPlan.ba.bFree)"
                          class="expire-date"
                          v-html="$t('userInfo.myInformation.deactivateInfo.canNot.currentPlan.expireDate', { endDate: formatEndDate(lastPlan.ba.useEndDate) })"></span>
                    <div v-else class="cancel-subscription">
                      <ui-button :iconName="'icon--link'"
                                 @click="onMoveCancelSubscription('ba')">{{ $t('common.cancelSubscription') }}</ui-button>
                    </div>
                  </li>
                  <li v-if="isUsingService.beusable">
                    <i class="icon icon--logo-only-beu"></i>
                    <span class="plan-name">{{ lastPlan.beusable.planName }}</span>
                    <span v-if="lastPlan.beusable.bFree"
                          class="expire-date"
                          v-html="$t('userInfo.myInformation.deactivateInfo.can.plan')"></span>
                    <span v-else-if="lastPlan.beusable.paymentMethod === 'wire transfer' || lastPlan.beusable.coupon || !lastPlan.beusable.paymentMethod || ['admin', '4grit'].includes(lastPlan.beusable.paymentMethod)"
                          class="expire-date"
                          v-html="$t('userInfo.myInformation.deactivateInfo.canNot.currentPlan.expireDate', { endDate: formatEndDate(lastPlan.beusable.useEndDate) })"></span>
                    <div v-else class="cancel-subscription">
                      <ui-button :iconName="'icon--link'"
                                 @click="onMoveCancelSubscription('beusable')">{{ $t('common.cancelSubscription') }}</ui-button>
                    </div>
                  </li>
                  <li v-if="isUsingService.geo">
                    <i class="icon icon--logo-only-geo"></i>
                    <span class="plan-name">{{ lastPlan.geo.planName }}</span>
                    <span v-if="lastPlan.geo.bFree"
                          class="expire-date"
                          v-html="$t('userInfo.myInformation.deactivateInfo.can.plan')"></span>
                    <span v-else-if="lastPlan.geo.paymentMethod === 'wire transfer' || lastPlan.geo.coupon || !lastPlan.geo.paymentMethod || ['admin', '4grit'].includes(lastPlan.geo.paymentMethod)"
                          class="expire-date"
                          v-html="$t('userInfo.myInformation.deactivateInfo.canNot.currentPlan.expireDate', { endDate: formatEndDate(lastPlan.geo.useEndDate) })"></span>
                    <div v-else class="cancel-subscription">
                      <ui-button :iconName="'icon--link'"
                                 @click="onMoveCancelSubscription('geo')">{{ $t('common.cancelSubscription') }}</ui-button>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </content-box>
          <div class="button--wrap">
            <ui-button class="btn__cancel"
                       @click="onCancelDeactivate">{{ $t('common.cancel') }}</ui-button>
            <ui-button :primary="true"
                       @click="onMoveContactUs">{{ $t('common.contactUs') }}</ui-button>
          </div>
        </template>
      </div>
    </transition>
    <dimmed v-if="useDimmed">
      <deactivate
        v-if="isShowConfirmDeleteLayer"
        @onCloseLayer="isShowConfirmDeleteLayer = false"/>
    </dimmed>
  </div>
</template>

<script>
import ContentBox from '@/components/ui/ContentBox'
import UiButton from '@/components/ui/UiButton'
import BackToTop from '@/components/ui/BackToTop'
import UiCheckbox from '@/components/ui/UiCheckbox'
import Dimmed from '@/components/ui/Dimmed'
import Deactivate from '@/components/user-info/my-information/Deactivate'
import { deactivateInfo } from '@/api/user'
import { mapState } from 'vuex'
import { getDialog } from '@/libs/vue-utils'
import { getLocaleDateStr, openContactUs, openBeusableManagePlan, openGeoManagePlan } from '@/libs/utils'
import { getRemainJam } from '@/api/jam'

const openDialog = getDialog('dialogType')

export default {
  name: 'deactivateInfo',
  components: {
    ContentBox,
    UiButton,
    BackToTop,
    UiCheckbox,
    Dimmed,
    Deactivate
  },
  data () {
    return {
      isLoading: true,
      isShowConfirmDeleteLayer: false,
      model: {
        withDrawAgree: false
      },
      modelError: false,
      deactivateInfo: null,
      jam: {
        total: 0,
        free: 0,
        paid: 0
      }
    }
  },
  computed: {
    ...mapState([
      'userData'
    ]),
    useDimmed () {
      return this.isShowConfirmDeleteLayer
    },
    beusablePlan () {
      return this.deactivateInfo.beusable
    },
    baPlan () {
      return this.deactivateInfo.ba
    },
    geoPlan () {
      return this.deactivateInfo.geo
    },
    isUsingService () {
      return {
        beusable: !!(this.beusablePlan && this.beusablePlan.current),
        ba: !!(this.baPlan && this.baPlan.current),
        geo: !!(this.geoPlan && this.geoPlan.current)
      }
    },
    canDeactivate () {
      return this.canDeactivateService.beusable && this.canDeactivateService.ba && this.canDeactivateService.geo
    },
    canDeactivateService () {
      return {
        beusable: !this.isUsingService.beusable ||
          (this.beusablePlan && this.beusablePlan.current.bFree && !this.beusablePlan.between),
        ba: !this.isUsingService.ba ||
          (this.baPlan && this.baPlan.current.bFree && !this.baPlan.between),
        geo: !this.isUsingService.geo ||
          (this.geoPlan && this.geoPlan.current.bFree && !this.geoPlan.between)
      }
    },
    lastPlan () {
      return {
        beusable: this.beusablePlan ? (this.beusablePlan.between || this.beusablePlan.current) : null,
        ba: this.baPlan ? (this.baPlan.between || this.baPlan.current) : null,
        geo: this.geoPlan ? (this.geoPlan.between || this.geoPlan.current) : null
      }
    },
    nextPlan () {
      return {
        beusable: this.beusablePlan ? this.beusablePlan.next : null,
        ba: this.baPlan ? this.baPlan.next : null,
        geo: this.geoPlan ? this.geoPlan.next : null
      }
    },
    unusedJam () {
      if (this.jam.total > 0) {
        return 'deactivated'
      } else {
        return 'activated'
      }
    }
  },
  methods: {
    formatEndDate (date) {
      return getLocaleDateStr(date)
    },
    onCancelDeactivate () {
      this.$emit('closeWithdraw')
    },
    onChangeCheckboxValue () {
      this.model.withDrawAgree = !this.model.withDrawAgree
      this.modelError = false
    },
    onMoveContactUs () {
      openContactUs(this.userData)
    },
    onMoveCancelSubscription (service) {
      if (service === 'beusable') {
        openBeusableManagePlan()
      } else if (service === 'ba') {
        this.$router.push({ name: 'managePlan', params: { action: 'downgradePlan' } })
      } else {
        openGeoManagePlan()
      }
    },
    onShowConfirmDeleteLayer () {
      if (!this.model.withDrawAgree) {
        this.modelError = true
        return false
      }
      this.isShowConfirmDeleteLayer = true
    },
    setRemainJam () {
      const payload = {
        user_id: this.userData.userId,
        user_num: this.userData.userNum
      }
      getRemainJam(payload).then(res => {
        this.jam.total = res.paidCount + res.freeCount
        this.jam.free = res.freeCount
        this.jam.paid = res.paidCount
      }).catch(err => {
        console.log(err)
      })
    }
  },
  created () {
    this.setRemainJam()
    deactivateInfo().then(response => {
      this.deactivateInfo = response
      this.isLoading = false
    }).catch(() => {
      this.isLoading = false
      openDialog('common.error')
    })
  }
}
</script>

<style lang="scss" scoped="scoped">
.content__body {
  height: calc(100% - 50apx);
  padding: 30px 30px 0;
  overflow-y: auto;
  text-align: center;

  .content__withdraw {
    margin: 0 auto;
    padding: 45px 25px;
    color: #444;
    border: solid 2px #ec0047;

    &.no-deactivate {
      padding-bottom: 27px;

      .title--wrap {
        .title {
          padding: 15px 0;
        }
      }
    }

    &.can-deactivate {
      .title--wrap {
        border-bottom: 1px solid #d8d8d8;
        padding-bottom: 28px;
      }
    }

    .title--wrap {
      width: 700px;
      margin: 0 auto;

      .title {
        font-size: 22px;
        font-weight: 500;
        line-height: 1.45;
      }
      strong {
        display: inline-block;
        margin-top: 14px;
        font-size: 15px;
        font-weight: 500;
        line-height: 1;
        color: $brandColor;
      }

      i {
        margin: 20px 15px 5px 15px;
        vertical-align: middle;

        &.icon--logo-red {
          width: 126px;
          height: 20px;
          background-size: 100% 100%;
        }

        &.icon--logo-bly {
          margin-bottom: 1px;
          width: 126px;
          height: 28px;
          background-size: 100% 100%;
        }
      }
    }

    .desc--wrap {
      padding-top: 50px;
      padding-bottom: 20px;

      p {
        &:nth-of-type(1) {
          font-size: 15px;
          font-weight: 500;
        }
        &:nth-of-type(2) {
          margin-top: 25px;
          margin-bottom: 20px;
          font-size: 14px;
          line-height: 1.43;
        }
      }
    }

    .analytics-page--wrap,
    .current-plan--wrap {
      margin: 0 auto;
      width: 750px;
      border: solid 8px #e6e6e6;
      padding: 26px;
      text-align: left;
      box-sizing: border-box;
      &.center {
        text-align: center;
      }
    }

    .analytics-page--wrap {
      ul {
        margin: -8px 0;
        li {
          margin: 15px 0 15px 113px;

          h5 {
            font-size: 15px;
            color: #ec0047;
            display: inline-block;
            width: 120px;
            position: relative;
            vertical-align: top;

            &:not(.no-bullet)::before {
              position: absolute;
              top: 5px;
              left: -10px;
              content: "";
              width: 4px;
              height: 4px;
              border-radius: 4px;
              background-color: #ec0047;
            }
          }

          p {
            font-size: 14px;
            color: #444444;
            display: inline-block;
            vertical-align: top;
          }
        }
      }
      .unused-jam--wrap {
        padding: 30px 110px 70px 110px;
        text-align: center;
        .description {
          font-size: 14px;
          line-height: 20px;
          color: #ec0047
        }
        .jam-info {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 50px;
          position: relative;
          .jam {
            display: flex;
            align-items: center;
            span {
                margin-left: 5px;
                color: #444444;
                font-size: 16px;
                font-weight: 700;
              }
          }
          div {
            font-size: 16px;
            font-weight: 400;
            color: #ec0047;
            span {
              color: #444444;
            }
          }
        }
        .jam-info::after {
          content: '';
          width: 100%;
          border: 1px dashed #E6E6E6;
          position: absolute;
          bottom: -10px;
        }
      }
    }

    .current-plan--wrap {
      text-align: center;
      margin-top: 32px;

      & > div {
        @include flexYcenter;
      }

      .desc {
        margin-top: 21px;
        font-size: 14px;
        line-height: 1.43;
        color: #ec0047;
      }

      ul {
        width: 483px;
        margin: 52px auto 10px auto;

        li {
          white-space: nowrap;
          display: flex;
          justify-content: space-between;
          height: 38px;
          align-items: center;
          padding-bottom: 13px;
          margin-bottom: 13px;
          border-bottom: 1px dashed #d7d7d7;

          & > * {
            width: 32.5% !important;
          }

          i {
            width: 35% !important;
            background-position: center left;

            &.icon--logo-horizontal {
              background-size: 169px 22px;
            }

            &.icon--logo-beu {
              background-size: 97px 15px;
            }

            &.icon--logo-bly {
              background-size: 97px 22px;
            }
          }

          .plan-name {
            font-size: 16px;
            font-weight: 500;
            color: #444444;
            width: 70px;
            text-align: center;
            display: inline-block;
            white-space: nowrap;
          }

          .expire-date {
            text-align: center;
            display: inline-block;
            width: 150px;
            font-size: 14px;
            color: #444444;
          }

          .cancel-subscription {
            position: relative;
            height: 38px;
            text-align: center;

            .ui-btn {
              font-size: 13px;
              font-weight: 500;
              color: #444444;
            }
          }
        }
      }
    }

    .chk-box--wrap {
      position: relative;
      margin-top: 30px;
      margin-bottom: 20px;

      .validation-text {
        @include validErrorText;
        position: absolute;
        left: 50%;
        bottom: -20px;
        transform: translateX(-50%);
      }
    }
  }

  .button--wrap {
    margin-top: 30px;
    margin-bottom: 127px;
    text-align: center;

    .ui-btn {
      padding: 0 30px;

      &.btn__cancel {
        margin-right: 5px;
      }
    }
  }

  &.loading-enter-active,
  &.loading-leave-active {
    transition: opacity 0.3s ease;
  }

  &.loading-enter,
  &.loading-leave-to{
    opacity: 0;
  }
}
</style>
